import { FileAttachment } from "src/app/shared/models/file-attachment.model";

export class LibraryDetails {
  Id: number;
  Name: string;
  File: FileAttachment[] = [];
  Type: number;
  ParentId: number = null;
  Version: string;
  CreatedBy: number;
  checked: boolean = false;
}
